/* NEEDS to be separate from the .data file because these functions can only be used on the front or back end, not in share */

import { MonthFull, MonthAbbr, AUS_SYD_TIMEZONE } from '../../../globals/helpers/constants'
import {  getUTCstringFromProgramAndTime } from '../../../globals/helpers/helpers'
import { PublicEventData } from '../../../globals/store/public.model'
import { PublishInfo } from '../../../globals/store/share.data'
import { EventListInfo, EventListPublish, EventListPublishInstance, ProgramPublishCalendarData } from '../../../globals/store/share.event-lists.data'
import { flatten, getSet, setIntersection } from 'globals/helpers/helpers'
import { extractStartEndDateParts } from 'globals/helpers/share.event-list.helper'


export const extractSingleEventListPublishCalendarData = (publishData: PublicEventData, publishInfo: PublishInfo, eventListExcludedIds: string[]): ProgramPublishCalendarData => { // leaving filtering of publish info by publish info excluded ids and event list excluded ids for now, but passing in for future use
  const { venue, timeline, eventInfo, timeZoneIdsByProgram } = publishData
  const { title, event_title, eventId } = eventInfo
  const sessionDays:{[day:string]:{start:string, end:string, programId:string}} = {}
  flatten(timeline).filter(item => item.date).forEach((item, idx, arr)=>{
    if(!sessionDays[item.session_date]) sessionDays[item.session_date] = {start:item.start, end:item.end, programId:item.program.id};
    else sessionDays[item.session_date].end = item.end;
  })
  const sessionDates = Object.keys(sessionDays).map(dayId=>{
    const timezone = timeZoneIdsByProgram[sessionDays[dayId].programId] || AUS_SYD_TIMEZONE
    return {
      start:getUTCstringFromProgramAndTime(dayId, timezone, sessionDays[dayId].start),
      end:getUTCstringFromProgramAndTime(dayId, timezone, sessionDays[dayId].end)
    }
  })
  if (!sessionDates.length) return null
  return {
    publishId: publishInfo.publishCode,
    publishTitle: title,
    eventId,
    eventTitle: event_title,
    days:sessionDates,
    venue: eventListExcludedIds.includes('mainVenue') ? null : venue || null,
  }
}

// needs to be in app because of getUTCOffset / findTimeZone
export const extractEventListPublishCalendarData = (instances: EventListPublishInstance[], publishedIds: string[], publishedDatas: {[code:string]: PublicEventData },  publishInfos: { [id:string]: PublishInfo }, eventListExcludedIds: string[]): { [id: string]: ProgramPublishCalendarData } => {
  const allInstancePublishes = flatten(instances.map(i => i.publishes))
  const usedAndAvailablePublishIds = setIntersection(getSet(allInstancePublishes, 'id'), new Set(publishedIds))
  const publishCalendarData: { [publishId: string]: ProgramPublishCalendarData } = {}
  // console.log({ usedAndAvailablePublishIds, publishedDatas, instances, publishedIds })
  usedAndAvailablePublishIds.forEach(publishId => {
    const calendarData = extractSingleEventListPublishCalendarData(publishedDatas[publishId], publishInfos[publishId], eventListExcludedIds)
    if (calendarData) publishCalendarData[publishId] = calendarData
  })
  return publishCalendarData
}

export const getDateRangeForStartEndDates = (dates: { start: string, end: string }): string => {
  const dateParts = extractStartEndDateParts(dates)
  if (!dateParts) {
    return "Date TBA"
  } else {
    const { s, e } = dateParts
    return JSON.stringify(s) === JSON.stringify(e) ? `${s.d} ${MonthFull[s.m]} ${s.y}` :
      `${s.d}${s.m !== e.m || s.y !== e.y ? ' ' + MonthFull[s.m] : ''}${s.y !== e.y ? ' ' + s.y : ''} - ${e.d} ${MonthFull[e.m]} ${e.y}`
  }
}


export const programPublishToEventListPublish = (id: string, publishedData: PublicEventData, excludedIds: string[], shareBase: string): EventListPublish => {
  const { eventInfo, CTALinks, venue, timeline, brandingData } = publishedData
  const sessionDates = flatten(timeline).filter(item => !item.displayDate && item.date).map(item => item.session_date as string)
  sessionDates.sort((a,b) => new Date(a).getTime() - new Date(b).getTime())
  let dates: { start: string, end: string } = null
  if (sessionDates.length) dates = { start: sessionDates[0], end: sessionDates[sessionDates.length - 1] }
  let dateString: string
  const dateParts = extractStartEndDateParts(dates)
  if (!dateParts) {
    dateString = "Date TBA"
  } else {
    const { s, e } = dateParts
    dateString = JSON.stringify(s) === JSON.stringify(e) ? `${s.d} ${MonthFull[s.m]} ${s.y}` :
      `${s.d}${s.m !== e.m || s.y !== e.y ? ' ' + MonthFull[s.m] : ''}${s.y !== e.y ? ' ' + s.y : ''} - ${e.d} ${MonthFull[e.m]} ${e.y}`
  }
  return {
    id,
    name: eventInfo.title || '',
    publishLink: excludedIds.includes('publishLinks') ? null : `${shareBase}publish/${id}`,
    dates,
    dateString: excludedIds.includes('dates') ? null : dateString || null,
    venue: excludedIds.includes('mainVenue') ? null : venue || null,
    CTALinks: excludedIds.includes('CTALinks') ? null : CTALinks || []
  }
}